import { AsyncLoadingSection, DisplayBlock, PageCard, PageCardSection, buildEndpoint, defaultDataTransform, useDataFetcher } from '@techsharegov/react-ui';
import { useCommitteeState } from './CommitteeProvider';
import { AgendaEndpoints } from 'Models/Routes';

export class CommitteeProfileModel {
  countyName?: string;
  name?: string;
  description?: string;
  dateCreatedDisplay?: string;
  location?: string;
  details?: string;
  meetingTimes?: string;
}

export const CommitteeProfile: React.FC = () => {
  const { committeeId } = useCommitteeState();

  const [data, loadingStatus] = useDataFetcher<CommitteeProfileModel>(
    buildEndpoint(AgendaEndpoints.committees.controllerActionString("profile"), committeeId),
    new CommitteeProfileModel(),
    defaultDataTransform,
    CommitteeProfileModel
  );

  return (
    <AsyncLoadingSection loadingStatus={loadingStatus}>
      <PageCard>
        <PageCardSection title={data.countyName + " County " + data.name}>
          <DisplayBlock
            title="Description"
            value={data?.description}
            width="100%"
          />
          <DisplayBlock
            title="Active From"
            value={data?.dateCreatedDisplay}
            width="100%"
          />
          <DisplayBlock
            title="Location"
            value={data?.location}
            width="100%"
          />
          <DisplayBlock
            title="Committee Details"
            value={data?.details}
            width="100%"
          />
          <DisplayBlock
            title="Meeting Times"
            value={data?.meetingTimes}
            width="100%"
          />
        </PageCardSection>
      </PageCard>
    </AsyncLoadingSection>
  );
};
